// import loggingService from '../services/util/loggingService'
// import dateService from '../services/util/dateService'

// var serviceName = 'qaqcService'
// var isDebug = false

var qaqcSelections = function () {
    return {
        identification: {
            siteName: 0,
            siteTypeId: 0,
            timePeriodId: 0,
            secondarySiteTypeList: 0,
            secondaryTimePeriodList: 0,
            landownership: 0,
            identifiers: 0
        },
        location: {
            streetAddress: 0,
            town: 0,
            lotBlock: 0,
            parcel: 0,
            accessNotes: 0,
            datumId: 0,
            utmZoneId: 0,
            easting: 0,
            northing: 0
        },
        nationalRegisterStatus: {
            disturbanceInstanceList: 0,
            disturbancePercent: 0,
            significantPeriodInstanceList: 0,
            themeInstanceList: 0,
            periodDescription: 0
        },
        investigativeHistory: {
            discoveryMethodInstanceList: 0,
            investigativeWorkInstanceList: 0,
            materialsCollectedId: 0,
            repositoryId: 0,
            otherRepository: 0
        },
        propertyDescription: {
            length: 0,
            width: 0,
            area: 0,
            propertyBoundaryList: 0
        },
        siteSetting: {
            siteSettingTopographyList: 0,
            siteSettingDivisionList: 0,
            siteSettingUniqueSettingList: 0,
            percentBareGround: 0,
            generalTopographicSetting: 0,
            siteSettingVegetationList: 0,
            siteSettingDepositionalTypeList: 0,
            aeolianSettingsId: 0,
            siteSettingAeolianTypeList: 0,
            subsurfacePotentialId: 0,
            siteSettingDepositEstimateBasisList: 0
        },
        siteNarrativeBuildingDescHistory: {
            siteNarrative: 0,
            buildingDescription: 0,
            buildingHistory: 0
        },
        prehistoricArtifact: {
            significantPeriodList: 0,
            hasTimeDiagnostics: 0,
            hasAffiliationDiagnostics: 0, //set equal to hasTimeDiagnostics
            assemblageDetailsList1: 0, //artifactCategoryId == 1, Chipped Stone
            assemblageDetailsList2: 0, //artifactCategoryId == 2, Ground Stone
            assemblageDetailsList3: 0, //artifactCategoryId ==3, Ceramics / Steatite
            assemblageDetailsList4: 0, //artifactCategoryId == 4, Bone and Organic
            assemblageDetailsList5: 0, //artifactCategoryId == 5, Other Artifacts
            assemblageDetailsList6: 0, //artifactCategoryId == 6, Human Remains
            assemblageDetailsList11: 0, //artifactCategoryId == 11, Obsidian, set equal to assemblageDetailsList1
            assemblageSizeId: 0,
            keywords: 0,
            prehistoricInventoryList: 0
        },
        prehistoricFeature: {
            significantPeriodList: 0,
            assemblageDetailsList: 0,
            keywords: 0,
            prehistoricFeatureInventoryList: 0
        },
        historicArtifact: {
            significantPeriodList: 0,
            assemblageDetailsList7: 0, //artifactCategoryId == 7, Vessel Glass
            assemblageDetailsList8: 0, //artifactCategoryId == 8, Cans
            assemblageDetailsList9: 0, //artifactCategoryId == 9, Structural Artifacts
            assemblageDetailsList10: 0, //artifactCategoryId == 10, Domestic Artifacts
            assemblageDetailsList11: 0, //artifactCategoryId == 11, Industrial Artifacts
            assemblageSizeId: 0,
            keywords: 0,
            historicArtifactInventoryList: 0
        },
        historicFeature: {
            significantPeriodList: 0,
            assemblageDetailsList: 0,
            hasHumanRemains: 0,
            hasSuspectedGrave: 0, //set equal to hasHumanRemains
            hasHumanRemainsArtifacts: 0, //set equal to hasHumanRemains
            keywords: 0,
            historicFeatureInventoryList: 0
        },
        rockArt: [],
        historicBuilding: [],
        linearResource: {
            contributionId: 0,
            portionId: 0,
            topWidth: 0,
            bottomWidth: 0, //set equal to topWidth
            height: 0, //set equal to topWidth
            length: 0, //set equal to topWidth
            description: 0,
            associatedStructures: 0
        },
        structureObject: [],
        shapeFileAppend: {
            mediaId: null
        },
        unknownFeature: {
            assemblageDetailsList: 0,
            keywords: 0,
            unknownFeatureInventoryList: 0
        }
    }
}

// rockArtSelection object constructor
var rockArtSelection = function () {
    return {
        panelSelection: -1,
        currentPanelId: 0,
        panelAgeId: 0,
        panelLocationId: 0,
        //panelOrientation
        placementDescription: 0,
        rockType: 0,
        panelAspectId: 0,
        eastDegree: 0,
        heightBottom: 0,
        heightTop: 0, //set equal to heightBottom
        panelHeight: 0,
        panelWidth: 0, //set equal to panelHeight
        panelDistance: 0,
        panelDegree: 0, //set equal to panelDistance
        yesNoArcheologicalDepositsId: 0,
        //panelStyle
        culturalAffiliationId: 0,
        culturalAffiliationDesc: 0,
        selectedStyleList: 0,
        styleComments: 0,
        panelClassificationList: 0,
        keywords: 0,
        detailedDescription: 0,
        selectedBackgroundList: 0,
        featureIncorporation: 0,
        //panelDatingEvidence
        selectedDatingEvidenceList: 0,
        selectedConditionList: 0,
        preservationConcerns: 0,
        lightingCondition: 0,
        selectedRecordingList: 0
    }
}

// historicBuildingSelection object constructor
var historicBuildingSelection = function () {
    return {
        attachmentSelection: -1,
        currentFormId: 0,
        contributionId: 0,
        historicName: 0,
        otherCommonNames: 0,
        //HistoricBuildingFunctionList
        selectedCurrentFunction: 0,
        selectedHistoricFunction: 0,
        //HistoricBuildingSettingList
        selectedCurrentSetting: 0,
        selectedHistoricSetting: 0,
        settingDescription: 0,
        buildingStyleId: 0,
        buildingTypeId: 0, //set equal to buildingStyleId
        storyId: 0, //set equal to buildingStyleId
        yesNoBasementId: 0, //set equal to buildingStyleId
        historicBuildingElementList1: 0, //buildingElementId == 1, Roof
        historicBuildingElementList2: 0, //buildingElementId == 2, Walls
        historicBuildingElementList3: 0, //buildingElementId == 3, Foundation
        historicBuildingElementList4: 0, //buildingElementId == 4, Windows
        historicBuildingElementList5: 0, //buildingElementId == 5, Doors
        historicBuildingElementList6: 0, //buildingElementId == 6, Chimneys
        historicBuildingElementList7: 0, //buildingElementId == 7, Proches
        notableFeatures: 0,
        landscaping: 0,
        architecturalDescription: 0,
        buildingIntegrityId: 0,
        buildingConditionId: 0,
        comment: 0,
        historicBuildingConstructionDateList: 0,
        architect: 0,
        historicFunction: 0,
        alteration: 0,
        isNonExtant: 0
    }
}

var structureObjectSelection = function () {
    return {
        attachmentSelection: -1,
        currentFormId: 0,
        historicName: 0,
        otherCommonNames: 0,
        structureType: 0,
        associatedResources: 0,
        constructionDateList: 0,
        architectBuilder: 0,
        historicFunctions: 0,
        alterations: 0,
        currentUses: 0,
        historicUses: 0,
        description: 0,
        constructionMaterials: 0,
        styleType: 0,
        additionalNarrative: 0,
        isNonExtant: 0
    }
}

const excludedKeys = [
    'panelSelection',
    'currentPanelId',
    'attachmentSelection',
    'currentFormId'
]

export default {
    qaqcSelections: qaqcSelections,
    rockArtSelection: rockArtSelection,
    historicBuildingSelection: historicBuildingSelection,
    structureObjectSelection: structureObjectSelection,
    excludedKeys: excludedKeys
}



// WEBPACK FOOTER //
// ./src/services/qaqcService.js